import { ActionTree } from 'vuex';

import { IUapiState } from '@/store/modules/uapi/types';
import { IRootState } from '@/store/types';

export const actions: ActionTree<IUapiState, IRootState> = {
};
